exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 500px) {\n    .viewPort {\n        min-height: 800px;\n      }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main